<template>
  <div class="myAccount-bd">
    <div class="header">
      <div class="group rest">
        <div class="title">{{ $t('my_account_zu_lin_yu_e') }}</div>
        <div class="total-price">￥{{restData.balanceAmount || 0}}</div>
        <div class="price-list">
          <div class="price-item">{{ $t('my_account_ke_yong') }}：￥{{restData.canUseAmount || 0}}</div>
          <div class="price-item red">{{ $t('my_account_suo_ding') }}：￥{{restData.lockAmount || 0}}</div>
        </div>
        <div class="link-list">
          <div
            v-if="funcView.account_balance_detail"
            class="link-item"
            @click="checkRestDetails"
          >{{ $t('my_account_yu_e_ming_xi') }}</div>
          <div
            v-if="funcView.account_invoice_record"
            class="link-item"
            @click="checkInvoiceRecord"
          >{{ $t('my_account_fa_piao_ji_lu') }}</div>
        </div>
        <div class="fix-icon">
          <img
            src="~@/images/layout/icon-rest.png"
            alt=""
            class="img"
          >
        </div>
      </div>
      <div class="gutter"></div>
      <div class="group">
        <div class="title">{{ $t('my_account_ben_yue_dai_fu') }}</div>
        <div class="total-price">￥{{countData.wait2PayAmountThisMonth || 0}}</div>
        <div class="price-list">
          <div class="price-item">{{ $t('my_account_xia_yue_dai_fu') }}：￥{{countData.wait2PayAmountNextMonth || 0}}</div>
        </div>
        <div class="tips">
          <div class="icon icon-warning"></div>
          <div
            class="label"
            :title="$t('my_account_zdyqwfjcsyqfyqjscldzfzd')"
          >{{ $t('my_account_zdyqwfjcsyqfy') }}，{{ $t('my_account_qjscldzfzd') }}！</div>
        </div>
        <div class="fix-icon">
          <img
            src="~@/images/layout/icon-pay.png"
            alt=""
            class="img"
          >
        </div>
      </div>
      <div class="gutter">

      </div>
      <div class="group">
        <div class="title">{{ $t('my_account_ya_jin_zhang_hu') }}</div>
        <div class="total-price">￥{{depositData.paid || 0}}</div>
        <div class="price-list">
          <div class="price-item red">{{ $t('my_account_wei_jiao') }}：￥{{depositData.unpaid || 0}}</div>
        </div>
        <div class="link-list">
          <div
            v-if="funcView.account_deposit_detail"
            class="link-item"
            @click="checkDepositDetails"
          >{{ $t('my_account_ya_jin_ming_xi') }}</div>
        </div>
        <div class="fix-icon">
          <img
            src="~@/images/layout/icon-download.png"
            alt=""
            class="img"
          >
        </div>
      </div>
    </div>
    <div class="tab-content">
      <el-tabs v-model="billType">
        <el-tab-pane
          v-if="funcView.account_register_list"
          name="pay"
          :label="$t('my_account_zhi_fu_ding_dan')"
        ></el-tab-pane>
        <el-tab-pane
          v-if="funcView.account_my_account_list ||funcView.account_invoice_list "
          name="device"
          :label="$t('my_account_wo_de_zhang_dan')"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <pay-order v-if="billType === 'pay'" @update="onUpdate"></pay-order>
    <device-bill v-else></device-bill>
    <rest-details-dialog
      v-if="restDetailsVisible"
      @close="restDetailsVisible = false"
      :model="restDetailsModel"
    ></rest-details-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import payOrder from './children/pay_order.vue';
import deviceBill from './children/device_bill.vue';
import restDetailsDialog from './children/rest_details_dialog.vue';

// my_account_zu_lin_yu_e: 租赁余额// my_account_ke_yong: 可用// my_account_suo_ding: 锁定// my_account_yu_e_ming_xi: 余额明细// my_account_fa_piao_ji_lu: 发票记录// my_account_ben_yue_dai_fu: 本月待付// my_account_xia_yue_dai_fu: 下月待付// my_account_zdyqwfjcsyqfy: 账单逾期未付将产生逾期费用// my_account_qjscldzfzd: 请及时处理待支付账单// my_account_ya_jin_zhang_hu: 押金账户// my_account_wei_jiao: 未交// my_account_ya_jin_ming_xi: 押金明细// my_account_zdyqwfjcsyqfyqjscldzfzd: 账单逾期未付将产生逾期费用，请及时处理待支付账单！// my_account_zhi_fu_ding_dan: 支付订单// my_account_wo_de_zhang_dan: 我的账单// my_account_yu_e_ming_xi_1: 余额明细

export default {
  name: 'myAccount',
  components: {
    payOrder,
    deviceBill,
    restDetailsDialog,
  },
  computed: {},
  data() {
    return {
      // pay:支付订单  device：设备账单
      billType: '',
      customerId: '',
      countData: {
        // 下月待支付
        wait2PayAmountNextMonth: 0,
        // 当月待支付
        wait2PayAmountThisMonth: 0,
      },
      restData: {
        // 账户余额
        balanceAmount: 0,
        // 可用余额
        canUseAmount: 0,
        // 不可用金额
        lockAmount: 0,
      },
      // 押金
      depositData: {
        // 已付
        paid: 0,
        // 未付
        unpaid: 0,
      },
      restDetailsModel: {},
      restDetailsVisible: false,
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_myAccount');
    this.getFuncView();
  },
  methods: {
    i18nCallback() {
      this.billType = 'pay';
      this.init();
    },
    // 查看押金明细
    checkDepositDetails() {
      const url = '/rent/myAccount/payDeposit';
      this.jump(url);
    },
    // 查看发票记录
    checkInvoiceRecord() {
      const url = '/rent/myAccount/invoiceRecord';
      this.jump(url);
    },
    // 查看余额明细
    checkRestDetails() {
      this.restDetailsModel = {
        title: this.$t('my_account_yu_e_ming_xi_1'),
      };
      this.restDetailsVisible = true;
    },
    onUpdate() {
      this.getBaseCount();
      this.getRestCount();
      this.getDepositData();
    },
    init() {
      this.getBaseCount();
      this.getRestCount();
      this.getDepositData();
    },
    // 获取基础统计数据
    getBaseCount() {
      const reqData = {};
      return this.$getJSON(apis.PortalTotalBasic, reqData).then((res) => {
        this.countData = res.data;
      });
    },
    // 获取租赁余额
    getRestCount() {
      return this.$getJSON(apis.portalTotalTermBalance).then((res) => {
        this.restData = res.data;
      });
    },
    // 获取押金统计信息
    getDepositData() {
      return this.$getJSON(apis.portalTotalDeposit).then((res) => {
        this.depositData = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.myAccount-bd {
  padding: 24px;

  .icon-export-excel {
    font-size: 13px;
    padding-right: 7px;
  }
  > .header {
    display: flex;
    .group {
      flex: 1;
      width: 0;
      height: 165px;
      position: relative;
      background: #fff;
      border-radius: 16px;
      padding: 24px;

      .title {
        font-size: 14px;
        line-height: 20px;
        font-weight: bold;
        color: #4d4d4d;
      }

      .total-price {
        margin-top: 12px;
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        color: #202945;
      }

      .price-list {
        overflow: hidden;
        margin-top: 12px;
        .price-item {
          font-size: 14px;
          line-height: 20px;
          float: left;
          color: #4d4d4d;
          &:nth-child(n + 2) {
            margin-left: 16px;
          }

          &.red {
            color: #eb5a5a;
          }
        }
      }

      .link-list {
        margin-top: 16px;
        overflow: hidden;
        .link-item {
          float: left;
          color: rgba(0, 160, 217, 1);
          font-size: 12px;
          line-height: 17px;
          text-decoration: underline;
          cursor: pointer;
          &:nth-child(n + 2) {
            margin-left: 16px;
          }
        }
      }

      .tips {
        margin-top: 16px;
        line-height: 17px;
        overflow: hidden;

        font-size: 12px;
        > .icon {
          float: left;
          margin-left: 2px;
          color: #eb5a5a;
          line-height: 14px;
        }
        > .label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #1a1a1a;
          padding-left: 9px;
          cursor: pointer;
        }
      }

      .fix-icon {
        width: 44px;
        height: 44px;
        position: absolute;
        top: 24px;
        right: 24px;
        > .img {
          width: 100%;
          height: 100%;
          float: left;
        }
      }
    }
    .gutter {
      width: 24px;
      height: 1px;
    }

    .rest {
    }
  }
  .tab-content {
    padding: 24px 0 0px 16px;
  }
}
</style>
